import SV from 'server-vars';
import { localStorage } from 'dibs-browser-storage';
import { actionCreators } from '../../../actions';
import { PAGE_TYPE } from '../../../utils/pageConstants';
import isPageType from '../../../utils/isPageType';

const VIEW_COUNT_LOCAL_STORAGE_KEY = 'TRADE_REWARDS_NAVIGATION_TOOLTIP_VIEW_COUNT';

const isAllowedPageType: () => boolean = () =>
    !isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.CHECKOUT_CONFIRMATION]);

const hasSeenTooltip: () => boolean = () => localStorage.getItem(VIEW_COUNT_LOCAL_STORAGE_KEY) > 0;

export const tradeRewardsNavigationTooltipRule: () => Promise<boolean> = () =>
    Promise.resolve(
        SV.get('settings.isDesktop') &&
            SV.get('settings.isUserTypeTrade') &&
            isAllowedPageType() &&
            !hasSeenTooltip()
    );

export const tradeRewardsNavigationTooltipConfig = {
    name: 'tradeRewardsNavigationTooltip',
    rule: tradeRewardsNavigationTooltipRule,
    action: () => (dispatch: (arg: { type: string }) => void) => {
        localStorage.setItem(VIEW_COUNT_LOCAL_STORAGE_KEY, 1);
        return dispatch(actionCreators.showTradeRewardsNavigationTooltip());
    },
    priority: 430,
};
